import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const TopBar = ({ title, children }) => {
  const nav = useNavigate();
  return (
    <div className="flex items-center gap-3 border-b border-slate-700/70 bg-[#0b132b] px-3 py-2">
      <button
        type="button"
        data-testid="back-button"
        onClick={() => nav("/")}
        className="flex h-10 w-10 items-center justify-center rounded-full text-slate-300 transition-colors hover:bg-slate-800 hover:text-white"
      >
        <ArrowLeft className="h-5 w-5" />
      </button>
      <span className="mr-auto text-sm font-bold tracking-tight">{title}</span>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
};
